import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUsers } from '@estimation/entities/user/lib/hooks';
import classNames from 'classnames';
import { UserListSkeleton } from './UserListSkeleton';
import { Table } from '@shared/ui/Table';
import styles from './UserList.module.scss';
import { RemoveUser } from '@estimation/features/removeUser';
import { useTranslation } from 'react-i18next';
export function UsersList() {
    const { t } = useTranslation();
    const { users, isLoading } = useUsers();
    const isCurrentUserProjectOwner = true;
    const columns = makeColumns(t, isCurrentUserProjectOwner);
    return (_jsxs("div", { className: styles.container, children: [isLoading && _jsx(UserListSkeleton, {}), !isLoading && users.length === 0 && _jsx("div", { children: t('No users were found.') }), users.length > 0 && (_jsx(Table, { rows: users, loading: isLoading, columns: columns, disableRowSelectionOnClick: true, disableColumnResize: true, hideFooter: true, hideFooterSelectedRowCount: true, hideFooterPagination: true }))] }));
}
function makeColumns(tUser, isCurrentUserProjectOwner) {
    const renderHeader = (...titles) => (_jsx("div", { className: styles.header, children: titles.map((title, index) => (_jsx("span", { children: title }, index))) }));
    const columns = [
        {
            renderHeader: () => renderHeader(tUser('User Email')),
            field: 'email',
            flex: 8
        },
        {
            renderHeader: () => renderHeader(tUser('Status')),
            field: 'confirmed',
            headerClassName: styles.statusHeader,
            flex: 3,
            renderCell: ({ row }) => _jsx(ConfirmationStatus, { isConfirmed: row.confirmed })
        },
        {
            renderHeader: () => renderHeader(tUser('Delete')),
            field: 'delete',
            renderCell: ({ row }) => _jsx(RemoveUser, { user: row }),
            flex: 1,
            align: 'center',
            sortable: false
        }
    ];
    if (!isCurrentUserProjectOwner) {
        columns.pop();
    }
    return columns;
}
function ConfirmationStatus({ isConfirmed }) {
    const { t } = useTranslation();
    return (_jsx("div", { className: classNames(styles.confirmationStatus, {
            [styles.confirmationStatus__pending]: !isConfirmed,
            [styles.confirmationStatus__confirmed]: isConfirmed
        }), children: isConfirmed ? t('Confirmed') : t('Pending') }));
}
